import React from 'react'
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai'
import { useDispatch, useSelector } from 'react-redux'
import { clearRedux } from '../../redux/auth.slice'

const ModalLogin = ({closeModal, formik, onClickToSignIn, showPassword, setShowPassword}) => {

    const errorMessage = useSelector(state => state.auth.signIn.signInErrorMessage)
    const dispatch = useDispatch();

    if (errorMessage) {
        setTimeout(() => {
            dispatch(clearRedux())
        }, 2000)
    }

    return (
        <div className='modal-page'>
            <div
                className='modal-container'
            >
                <div className='modal-header'>
                    SIGN IN
                </div>
                <div className='modal-body'>
                    <div>
                        <label>Username: </label>
                        <input
                            name='username'
                            type='text'
                            value={formik.values.username}
                            placeholder='Enter your username'
                            onChange={(e) => {
                                formik.handleChange(e);
                                dispatch(clearRedux());
                            }}
                        />
                    </div>
                    <div>
                        <label>Password: </label>
                        <input
                            name='password'
                            type={showPassword ? "text" : "password"}
                            value={formik.values.password}
                            onChange={(e) => {
                                formik.handleChange(e);
                                dispatch(clearRedux());
                            }}
                            placeholder='Enter your password'
                        />
                        <span className='eye-icon'>
                            {showPassword ?
                                <AiFillEye onClick={() => setShowPassword(!showPassword)} />
                                :
                                <AiFillEyeInvisible onClick={() => setShowPassword(!showPassword)} />
                            }
                        </span>
                    </div>
                </div>
                <span id='err-message'>
                    {errorMessage}
                    {(formik.errors.username || formik.errors.password) && <> Account can't be blank! </>}
                </span>
                <div className='modal-footer'>
                    <button onClick={closeModal} type="button" className="btn-close">
                        Cancel
                    </button>
                    <button onClick={onClickToSignIn} type="button" className="btn-submit" >
                        Sign In
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ModalLogin